import { Controller } from 'stimulus'

export default class extends Controller
  @targets: ['overlay']
  
  triggerOverlay: (event) ->
    @overlayTarget.classList.add('panel-body__overlay--visible')
  
  clearOverlay: (event) ->
    @overlayTarget.classList.remove('panel-body__overlay--visible')